"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "type": "string",
  "format": "size",
  "enum": ["small", "medium", "large", "xl"],
  "enumNames": ["Small", "Medium", "Large", "XL"],
  "default": "small"
};
exports.default = _default;
module.exports = exports.default;